export interface BoostChoiceActions {
  /** Команда `chooseBoost` в бой (I1); окно затем убирает предложение. */
  chooseBoost(index: number): void;
}

const noop = () => {};

export const defaults: BoostChoiceActions = {
  chooseBoost: noop,
};

declare module "../actions" {
  interface WindowActions extends BoostChoiceActions {}
}
